<template>
  <tr>
    <th
      v-for="header in props.headers"
      :key="header.text"
      :class="[header.sortable ? 'column sortable': '', pagination.descending ? 'desc' : 'acs', header.value === pagination.sortBy ? 'active' : '', header.align === 'left' ? 'text-xs-left' : '', header.align === 'right' ? 'text-xs-right' : '']"
      class="subheading font-weight-light krita-dark text--darken-3"
      @click="changeSort(header.value,header.sortable)">
      {{ header.align === 'left' ? header.text : '' }}
      <v-icon
        v-if="header.sortable"
        small>arrow_upward</v-icon>
      {{ header.align === 'right' ? header.text : '' }}
      {{ header.align === undefined ? header.text : '' }}
    </th>
  </tr>
</template>

<script>
    export default {
        name: "DataGridSort",
        props: ['props','pagination','items'],
        data() {
            return {
                sort: {
                    sortBy: '',
                    descending: false
                },
            }
        },
        methods: {
            changeSort (column,sortable)
            {
                let self = this;

                if (!sortable)
                {
                    return;
                }
                if (self.pagination.sortBy === column)
                {
                    self.sort.descending = !self.pagination.descending;
                    self.sort.sortBy = column;
                }
                else
                {
                    self.sort.sortBy = column;
                    self.sort.descending = false;
                }
                self.$emit('changeSort',self.sort);
            },















            sortItems ()
            {
              let self= this;

              let headers = self.props.headers;
              let type = undefined;
              let sortBy = self.pagination.sortBy;
              for (let i= 0; i < headers.length; i++) {
                if (headers[i].value === self.pagination.sortBy)
                {
                  type = headers[i].type
                }
              }
              let itemsClient = [];

              switch (type) {
                case 'int':
                  self.sortByInt ();
                  break;
                case 'date':
                  break;
                case 'string':
                      self.sortByStrings();
                      break;
              };
              itemsClient = self.items;
              self.$emit('sortItems',itemsClient);
            },
            sortByStrings ()
            {
              let self = this;

              let sortBy = self.pagination.sortBy;
              self.items.sort((a,b) => (a[sortBy] > b[sortBy]) ? 1 : ((a[sortBy] < b[sortBy]) ? -1 : 0));
            },
            sortByInt ()
            {
              let self = this;

              let sortBy = self.pagination.sortBy;

              self.items.sort((a,b) => a[sortBy] - b[sortBy]);
            }
        }
    }
</script>

<style scoped>

</style>